module.exports = __webpack_public_path__ + "6529bfdd58aa22f9beda6f0d6c0e6da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_25.jpg
// module id = 1670
// module chunks = 5